import React, { useState, useEffect } from 'react';
import { TextField as MUITextField } from '@mui/material';
import { useSelector } from 'react-redux';
import TEXT from './text';

const PhoneNumberComponent = ({ properties, value, valueUpdaterCallback, validityUpdaterCallback }) => {
    const language = useSelector(state => state.App_Settings.language);
    const { options = {}, constrains = {} } = properties;

    const [inputValue, setInputValue] = useState(value !== undefined ? value : (options.defaultValue || options.value || ''));
    const [error, setError] = useState(false);

    // Sync with parent value changes
    useEffect(() => {
        if (value !== undefined && value !== inputValue) {
            setInputValue(value);
        }
    }, [value]);

    const handleChange = (event) => {
        const newValue = event.target.value;

        // Allow only digits and the '+' character
        if (!/^[\d+]*$/.test(newValue)) {
            setError(true);
            return;
        }

        setError(false);

        if (constrains.pattern && !new RegExp(constrains.pattern).test(newValue)) {
            return;
        }

        setInputValue(newValue);

        // Notify parent component
        if (valueUpdaterCallback) {
            valueUpdaterCallback(newValue);
        }

        // Update validity
        if (validityUpdaterCallback) {
            const isValid = options.required ? newValue.trim() !== '' : true;
            validityUpdaterCallback(isValid);
        }

        if (options.onChange) {
            options.onChange(newValue);
        }
    };

    return (
        <MUITextField
            label={options.label || TEXT.PhoneNumber[language]}
            type="tel"
            variant={options.variant || 'outlined'}
            value={inputValue}
            onChange={handleChange}
            placeholder={options.placeholder || ''}
            fullWidth={options.fullWidth !== false}
            required={options.required || false}
            error={error}
            helperText={error ? TEXT.InvalidPhoneNumber[language] : ''}
            inputProps={{
                pattern: constrains.pattern || undefined,
            }}
            sx={{ width: '100%', maxWidth: '100%' }}
        />
    );
};

export default PhoneNumberComponent;
